import { Injectable, Injector } from '@angular/core';
import { map, shareReplay, take, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from './api-helper.service';
export type ConfigIdType = "foreignAdmits" | "foreignAssist" | "category" | "modules" | "sources" | "formlyForms" | "dataModels" | "interviewPreparationPlans" | "navItems" | "UserRoleTypes" | "countrywiseServices" | 'visaPlans';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public _allConfigurationData: any;
  constructor(
    private apiHelperService: ApiHelperService,
    private injector: Injector
  ) {
    // console.log("calling config from config")
    // this.getAllConfig();
  }

  getConfig1(configId: ConfigIdType, propertyName?: string) {
    let result;
    if (this._allConfigurationData && this._allConfigurationData instanceof Array) {
      this._allConfigurationData.map((data) => {
        if (data.id == configId) {
          if (data?.config) {
            if (propertyName) {
              result = data["config"][propertyName]
            }
            else {
              result = data["config"]
            }
          }
        }
      });
    }
    else {
      result = []
    }
    return result
  }

  getConfig(configId: ConfigIdType, propertyName?: string) {
    return this.apiHelperService.getDataById("configurations", configId).pipe(shareReplay(1), map((data: any) => {
      return propertyName ? data.config[propertyName] : data.config;
    })/* , tap(data => console.log(data)) */);

    //filter data as per configId, property and return result []object.
  }

  getConfigByFilter(configId: ConfigIdType, moduleName?: string) {
    return this.getConfig(configId).pipe(map((res: any) => {     //use the returned getConfig[] to get the result.
      return res.filter(item => item.moduleName == moduleName);
    }))
  }

  //create getConfig1, getConfigByFilter1 with new logic to test. If okay implement the same with old name.


  async getAllConfig() {
    const result = await this.apiHelperService.getData("configurations");
    this._allConfigurationData = result;
    return this._allConfigurationData;
  }

  /**
   * Enhanced getKeyConfiguration with auto-PUID detection
   * Maintains backward compatibility while adding security
   */
  async getKeyConfiguration(keyName: string): Promise<any> {
    const puid = this.getCurrentPuid();

    if (puid) {
      // Use secure PUID-specific API
      const config = await this.getConfigurationByPuid(puid);
      return config?.[keyName] || [];
    } else {
      console.warn(`No PUID found, loading ${keyName} globally (less secure)`);
      // Fallback for non-PUID contexts
      const result = await this.apiHelperService.getData("configurations/" + keyName) as any;
      const dataArray = result?.data || [];
      this._allConfigurationData = dataArray;
      return this._allConfigurationData;
    }
  }

  /**
   * Auto-detect PUID from current route using ActivatedRoute
   */
  private getCurrentPuid(): string | null {
    try {
      // Get ActivatedRoute service from injector
      const activatedRoute = this.injector.get(ActivatedRoute);

      // Check current route and all child routes for puid parameter
      let currentRoute = activatedRoute;
      while (currentRoute) {
        const puid = currentRoute.snapshot?.params?.puid;
        if (puid) {
          return puid;
        }
        currentRoute = currentRoute.firstChild;
      }

      // Fallback: Parse from URL if route params don't have puid
      const router = this.injector.get(Router);
      const url = router.url;
      const puidMatch = url.match(/\/([a-f0-9]{24})(?:\/|$)/); // MongoDB ObjectId pattern
      return puidMatch ? puidMatch[1] : null;

    } catch (error) {
      console.warn('Could not detect PUID from route:', error);
      return null;
    }
  }


  filterData(configId: string, moduleName: string, data: any[]) {
    const singleObj = data.find(single => single.id === configId);
    if (configId === "category") {
      return singleObj.config.filter((single: any) => {
        return single.moduleName === moduleName
      });
    }
    else if (configId === "modules") {
      return singleObj.config[moduleName];
    } else if (configId === "foreignAssist" && moduleName) {
      return singleObj.config[moduleName];
    } else {
      return singleObj;
    }
  }


  getCustomConfig() {
    return this.apiHelperService.getData("configurations");
  }

  /**
   * Get PUID-specific configuration from the new secure API
   * @param puid - The PUID to fetch configuration for
   * @returns Promise with PUID-specific configuration
   */
  async getConfigurationByPuid(puid: string): Promise<any> {
    try {
      const result = await this.apiHelperService.getData(`configurations/puid/${puid}`) as any;

      if (result?.success && result?.config) {
        this._allConfigurationData = result.config;
        return result.config;
      } else {
        console.error(`Configuration not found for PUID: ${puid}`, result?.message || 'Unknown error');
        return null;
      }
    } catch (error) {
      console.error(`Failed to fetch configuration for PUID ${puid}:`, error);
      return null;
    }
  }

}
